import { TableStatus } from '../enums/table-status.enum';

/** Sede o ubicación del restaurante (puede haber varias). */
export class Location {
  id: string;
  name: string;
  address?: string;
  active: boolean = true;

  constructor(id: string, name: string, address?: string) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.active = true;
  }
}

export interface DoorMarker {
  id: string;
  x: number;
  y: number;
}

export interface KitchenMarker {
  id: string;
  x: number;
  y: number;
}

export class Zone {
  id: string;
  name: string;
  type: 'PISO' | 'SALA' | 'TERRAZA' | 'BARRA' | 'VIP';
  description?: string;
  /** ID de la sede (Location) a la que pertenece la zona. */
  locationId: string | null = null;
  doors: DoorMarker[] = [];
  kitchens: KitchenMarker[] = [];
  /** Si false, la zona está inactiva (histórico); no se borra si tiene pedidos. */
  active: boolean = true;

  constructor(id: string, name: string, type: 'PISO' | 'SALA' | 'TERRAZA' | 'BARRA' | 'VIP') {
    this.id = id;
    this.name = name;
    this.type = type;
    this.doors = [];
    this.kitchens = [];
    this.active = true;
  }
}

export class Table {
  id: string;
  number: number;
  capacity: number;
  status: TableStatus;
  zoneId: string;
  positionX: number; // para drag & drop
  positionY: number; // para drag & drop
  groupId?: string; // ID del grupo si está unida a otras mesas
  linkedTables?: string[]; // IDs de mesas unidas
  /** Si false, la mesa está inactiva (histórico); no se borra si tiene pedidos. */
  active: boolean = true;
  /** Código temporal (aleatorio) para acceso vía QR; no expone información de la mesa. */
  accessCode: string = '';
  createdAt: Date;
  updatedAt: Date;

  constructor(
    id: string,
    number: number,
    capacity: number,
    zoneId: string,
    positionX: number = 0,
    positionY: number = 0
  ) {
    this.id = id;
    this.number = number;
    this.capacity = capacity;
    this.status = TableStatus.AVAILABLE;
    this.zoneId = zoneId;
    this.positionX = positionX;
    this.positionY = positionY;
    this.createdAt = new Date();
    this.updatedAt = new Date();
  }

  isLinked(): boolean {
    return !!this.groupId;
  }

  get tableNumber(): number {
    return this.number;
  }

  getTotalCapacity(): number {
    return this.capacity;
  }

  unlink(): void {
    this.groupId = undefined;
    this.linkedTables = undefined;
  }
}
